// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-details[data-v-6c034349]{gap:8px}.downgrade_label[data-v-6c034349]{border-top:1px dashed #d8d8df}", ""]);
// Exports
module.exports = exports;
